import { appConfig } from '@/config/app.ts'
import { DailyCutCashOut } from '@/modules/services/dailyCut/types/DailyCutCashOut.ts'

export interface DailyCutState {
  filters: string
  isProcesarPagoModalOpen: boolean
  selectedRows: DailyCutCashOut[]
}

export const initialState: DailyCutState = {
  filters: `?limit=${appConfig.pagination.defaultValue}`,
  isProcesarPagoModalOpen: false,
  selectedRows: []
}
